export default {
    /**
     * Sum up the given numbers in the array.
     *
     * @param {Array.<number|string>} toSum
     * @return {number}
     */
    sum(toSum: Array<number | string>): number {
        if (!Array.isArray(toSum)) throw new Error(`Expected an array, received a ${typeof(toSum)}`);
        let total = 0;
        for (let i = 0; i < toSum.length; i++) {
            // @ts-ignore - TS isn't seeing the check
            if (typeof(toSum[i]) === 'number') total += toSum[i];
            else if (typeof(toSum[i]) === 'string') total += Number(toSum[i]);
        }
        return total;
    },

    /**
     * Sum up the given numbers in the array.
     *
     * @param {Array.<number|string>} toMax
     * @return {number}
     */
    max(toMax: Array<number | string>): number {
        if (!toMax || toMax.length === 0) return 0;

        let max = Number(toMax[0]);
        for (let i = 1; i < toMax.length; i++) {
            // @ts-ignore - JS will automatically convert strings to numbers here
            if (toMax[i] > max) max = toMax[i];
        }

        return max;
    },

    /**
     * Sum up the given numbers in the array.
     *
     * @param {Array.<number|string>} toMin
     * @return {number}
     */
    min(toMin: Array<number | string>): number {
        if (!toMin || toMin.length === 0) return 0;

        let min = Number(toMin[0]);
        for (let i = 1; i < toMin.length; i++) {
            // @ts-ignore - JS will automatically convert strings to numbers here
            if (toMin[i] < min) min = toMin[i];
        }

        return min;
    },

    /**
     * Get the median value of an array
     * @param {number[]} arr
     * @returns {number}
     */
    median(arr: number[]): number {
        const mid = Math.floor(arr.length / 2),
            nums = [...arr].sort((a, b) => a - b);
        return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
    },

    /**
     * Sum up a particular field from an array of objects.
     *
     * @param {object[]} objects
     * @param {string} field
     * @param {boolean} [isCurrency]
     * @param {number} [precision]
     * @returns {number}
     */
    sumByField(objects: Record<string, any>[], field: string, isCurrency?: boolean, precision?: number | null): number {
        if (!objects || objects.length === 0) return 0;

		const toSum = objects.map(o => {
            if (isCurrency) return `${o[field]}`.replace(/[$,]+/g, "");
            else return o[field];
        });

        if (precision) return Number.parseFloat(this.sum(toSum).toFixed(precision));
        else return this.sum(toSum);
    },

    /**
     * Sum up a particular field from an array of objects.
     *
     * @param {object[]} objects
     * @param {string} field
     * @param {boolean} [isCurrency]
     * @param {number} [precision]
     * @returns {number}
     */
    minByField(objects: Record<string, any>[], field: string, isCurrency?: boolean, precision?: number): number {
        if (!objects || objects.length === 0) return 0;

        const toMin = objects.map(o => {
            if (isCurrency) return `${o[field]}`.replace(/[$,]+/g, "");
            else return o[field];
        });

        if (precision) return Number.parseFloat(this.min(toMin).toFixed(precision));
        else return this.min(toMin);
    }
};
